import React from 'react'
import ModalWrapper from '../ModalWrapper'
import RemoveBackupEmailContainer from '../../../containers/account/RemoveBackupEmailContainer'

const RemoveBackupEmailModal = (props) => {
  const { hideModal } = props
  return (
    <div className='emailVerificationFlow-modalContainer marketing'>
      <ModalWrapper hideModal={hideModal} showModalHeader={false} modalStyle='dark'>
        <div className='emailVerificationFlow-modalContent'>
          <RemoveBackupEmailContainer hideModal={hideModal} />
        </div>
      </ModalWrapper>
    </div>
  )
}

export default RemoveBackupEmailModal
